// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"aa823bff","453":"1ddfe5b3","743":"fe309f6c","872":"8d2c5c5f","924":"6cd53ecd"}[chunkId] + ".chunk.js";
};